// removed by extract-text-webpack-plugin
module.exports = {"container":"_-5QS2ky","header":"_3XVXPvs","body":"_2SyPnzx","footer":"_3xW3Ae8","small":"_2CfrGrH","optionListWrapper":"S97O2xk","optionList":"kQx1gKn","cta":"_271gBtw","errorWrapper":"_1TrNYB2","errorMessage":"_3YGziOA"};


//////////////////
// WEBPACK FOOTER
// ./template/components/GDPR/ContactPreferences/ContactPreferences.css
// module id = ./template/components/GDPR/ContactPreferences/ContactPreferences.css
// module chunks = client.sitechrome